/* eslint-disable import/prefer-default-export */
import axios from 'axios'
// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'

/**
 * @async
 * @description search cities
 * @param {string} search string to search
 * @param {Boolean} isCodeInsee true = search by code, false = search by libelle
 * @returns {Array<Object>} cities
 */
export const searchCities = async (search: any, birthDate: any, isCodeInsee = false): Promise<any[]> => {
    try {
        const newSearch = String(search).replace(' ', '-')
        const queryUrl = `${window._env_.REACT_APP_HDS_HOST}/cog?search=${newSearch}&isCodeInsee=${isCodeInsee}&birthDate=${birthDate}`
        const token = await ToktokdocLib.Utils.getSessionToken()
        const res = await axios.get(queryUrl, {
            headers: {
                'X-Session-Token': token,
            },
        })
        return res.data
    } catch (error) {
        console.error(error)
    }

    return []
}
